<template>
<div>
    <vue-headful title="Dashboard" />

    <dashboard-adm v-if="nivel === 1 || nivel === 2 || nivel === 8" />
    <dashboard-rh v-if="nivel === 3" />
    <dashboard-grupo-fornecedor v-if="nivel === 4 || nivel === 7" />
    <dashboard-cliente v-if="nivel === 6" />
    <dashboard-motorista v-if="nivel === 10" />
    <dashboard-financeiro v-if="nivel === 9" />

</div>
</template>

<script>
import DashboardAdm from '@/pages/Dashboard/DashboardAdm'
import DashboardFinanceiro from '@/pages/Dashboard/DashboardFinanceiro'
import DashboardRh from '@/pages/Dashboard/DashboardRh'
import DashboardGrupoFornecedor from '@/pages/Dashboard/DashboardGrupoFornecedor'
import DashboardCliente from '@/pages/Dashboard/DashboardCliente'
import DashboardMotorista from '@/pages/Dashboard/DashboardMotorista'
import Notify from '@/config/mixins/notify'

export default {
    components: {
        DashboardAdm,
        DashboardRh,
        DashboardGrupoFornecedor,
        DashboardCliente,
        DashboardFinanceiro,
        DashboardMotorista
    },

    data() {
        return {
            nivel: this.$store.state.usuario.niveis[0].id
        }
    },

    created() {
        this.authorize();
        if (this.nivel === 5) {
            this.$router.push({ name: 'pagamentosCreate' })
        } else  if (this.nivel === 12) {
            this.$router.push({ name: 'abastecimentosCreate' })
        } else  if (this.nivel === 13) {
            this.$router.push({ name: 'relatoriosView' })
        }
    },

    mixins: [Notify],

    methods: {
        authorize() {
            this.$http.get(this.$urlAPI + 'autorizado')
                .then(response => {

                })
                .catch(e => {
                    this.msgErrors(e)
                })
        }
    },

};
</script>

<style>
.stats {
    font-size: 16pt !important;
    padding-bottom: 10px !important;
    font-weight: 500 !important;
    color: #5a6268 !important;
}

.stats span {
    color: #0000FF !important;

}

.title {
    font-weight: 500 !important;
}
</style>
